import {
  Box,
  Grid,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import { FC, useState, useEffect } from "react";
import GoldTopBanner from "../../components/GoldTopBanner";
import { H3, Small } from "../../components/Typography";
import { useLocation } from "react-router-dom";
import { toast } from "react-hot-toast";
import { load, remove } from "../../constants/storage";
import { useAppDispatch } from "../../store/hooks";
import { useNavigate } from "react-router-dom";
import { getAddress } from "../../redux/actions";
import AddAddressModal from "../../components/AddAddressModal";
import AddIcon from "@mui/icons-material/Add";
import { buyGoldCoin } from "../../redux/actions/GoldSilverAction";
import DashboardNavbar from "../../components/DashboardNavbar";
import { PAYMENT_URL_DEV, MERCHANTS_ID } from "../../common/common";
const CoinPriceBreakup: FC = () => {
  let routeData = useLocation();
  const [count, setCount] = useState(1);
  const [getaddressData, setGetAddressData] = useState([]);
  const { selected, screenName } = routeData.state;

  //get User Address
  const dispatch = useAppDispatch();
  const [selectedAddress, setSelectedAddress] = useState<any>("");
  const [finaldata, setFinalData] = useState<any>();
  let navigate = useNavigate();
  //add address model
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSave = (value: any) => {
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < 4) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }

    let array = [];
    let finalArray: any = [];
    const data = {
      mobileNo: value.addressmobile,
      line1: value.address,
      city: value.city,
      state: value.state,
      pinCode: value.pincode,
      dataSource: "WEB_APP",
      fullName: value.username,
      addressMobileNo: value.addressmobile,
      country: "INDIA",
      userId: finalUser.id,
      id: result,
    };
    array.push(data);
    finalArray = [...getaddressData, ...array];
    setGetAddressData(finalArray);
    handleCloseModal();
  };

  //get Address
  useEffect(() => {
    checkToken();
  }, []);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getAddressAPI();
    }
  };

  const getAddressAPI = async () => {
    let token = load("token");
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    dispatch(getAddress(finalUser.id, token))
      .then(async (response: any) => {
        if (response?.status === 401) {
          return;
        }
        setGetAddressData(response);
      })
      .catch((error: any) => {
        console.log("------getAddress---error-----:", error);
      });
  };

  //count Increment
  const handleIncrement = () => {
    if (count * selected.basePrice + count * selected.gst > 200000) {
      toast.error("Cannot buy more then 2 lakh.");
    } else {
      setCount(count + 1);
    }
  };

  //count Decrement
  const handleDecrement = () => {
    if (count === 1) {
      return;
    } else {
      setCount(count - 1);
    }
  };

  const onProceed = () => {
    if (finaldata === undefined) {
      toast.error("Please select an address.");
    } else {
      let token: any = load("token");
      let userDetail: any = load("userData");
      let user = JSON.parse(userDetail);
      const code = user.country_code ? user.country_code : "+91";
      var newValue = code.toString().slice(1);
      const finalData = {
        mobileNo: newValue + user.mobile,
        productType: "gold",
        quantity: selected.weight * count,
        amount: (count * selected.basePrice + count * selected.gst).toFixed(2),
        userName: user.firstname + " " + user.lastname,
        userId: user.id,
        partnerId: user?.refcode,
        source: "partner",
        callBackUrl: process.env.REACT_APP_GS_CALL_BACK_URL,
        userAddressRequest: {
          mobileNo: finaldata.addressMobileNo,
          address: finaldata.line1,
          cityCode: finaldata.city,
          stateCode: finaldata.state,
          pinCode: finaldata.pinCode,
          fullName: finaldata.fullName,
          addressMobileNo: finaldata.addressMobileNo,
          country: "INDIA",
        },
        product: [
          {
            sku: selected.productCode,
            quantity: selected.weight,
          },
        ],
      };

      dispatch(buyGoldCoin(finalData, token))
        .then(async (response: any) => {
          console.log("------buyGoldCoin---response-----:", response);
          let newWindow: any = window.open("", "_self");
          await newWindow.document.write(`
            <html>
              <head>
                <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
                <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
                <title>Acru - Financial Wellness for All</title>
              </head>
              <body>
                <div id="waiting" style="display: block; font-family: sans-serif;">
                  <br /><br />
                  <center><h1>Please wait!</h1><h2> Do not refresh the page</h2></center>
                </div>
                <div id="done" style="display: none; font-family: sans-serif;">
                  <br /><br />
                  <center><h2>Payment has been cancelled.</h2><h4><nav><a href="/dashboard">Retry</a></nav></h4></center>
                </div>
                <div id="paytm-checkoutjs"></div>
                <script>
                  function hidewaiting() {
                    setTimeout(() => {
                      document.getElementById("waiting").style.display = "none";
                    }, 10000);
                  }
                  
                  function showdone() {
                    setTimeout(() => {
                      document.getElementById("done").style.display = "block";
                    }, 10000);
                  }
                  
                  function onScriptLoad() {
                    var config = {
                      root: "",
                      flow: "DEFAULT",
                      data: {
                        "orderId": "${response?.data?.orderId}",
                        "token": "${response?.data?.txnToken}",
                        "tokenType": "TXN_TOKEN",
                        "amount": "${response?.data?.amount}"
                      },
                      handler: {
                        notifyMerchant: function(eventName, data) {
                          console.log("eventName => ", eventName);
                          console.log("data => ", data);
                          if (eventName === "APP_CLOSED") {
                            showdone();
                            hidewaiting();
                            console.log("ddd");
                          } else {
                            showdone();
                          }
                          console.log("eventName => ", eventName);
                          console.log("data:::-->>", data.message);
                        }
                      },
                    };
                    
                    if (window.Paytm && window.Paytm.CheckoutJS) {
                      window.Paytm.CheckoutJS.onLoad(function excecuteAfterCompleteLoad() {
                        window.Paytm.CheckoutJS.init(config)
                          .then(function onSuccess() {
                            window.Paytm.CheckoutJS.invoke();
                          })
                          .catch(function onError(error) {
                            console.log("error => ", error);
                          });
                      });
                    }
                    
                    window.history.pushState(null, null, window.location.href);
                    window.onpopstate = function() {
                      window.history.pushState(null, null, window.location.href);
                    };
                  }
          
                  var scriptTag = document.createElement("script");
                  scriptTag.type = "application/javascript";
                  scriptTag.crossOrigin = "anonymous";
                  scriptTag.src = "${PAYMENT_URL_DEV}/merchantpgpui/checkoutjs/merchants/${MERCHANTS_ID}.js";
                  scriptTag.onload = onScriptLoad;
          
                  document.body.appendChild(scriptTag);
                </script>
              </body>
            </html>
          `);
        })
        .catch((error: any) => {
          console.log("------buyGoldCoin---error-----:", error);
        });
    }
  };

  return (
    <>
      <DashboardNavbar />
      <Box
        sx={{
          background: {
            md: "#fff",
            xs: "transparent",
          },
          pl: {
            md: 10,
            xs: 2,
            sm: 2,
          },
          pr: {
            md: 10,
            xs: 2,
            sm: 2,
          },
          pb: 2,
          pt: 2,
        }}
      >
        <GoldTopBanner />

        <Grid
          xs={12}
          md={12}
          sx={{
            display: "flex",
            flexDirection: {
              md: "row",
              xs: "column",
            },
            width: "100%",
            background: "#fff",
            boxShadow: {
              md: 2,
              xs: 0,
            },
            borderRadius: 2,
            mt: {
              md: 2,
              xs: 0,
            },
            pb: 4,
            justifyContent: "space-around",
          }}
        >
          <AddAddressModal
            open={openModal}
            handleClose={handleCloseModal}
            handleSave={handleSave}
            //nameValue={inputValue}
          />
          {/* left container */}
          <Grid
            xs={12}
            md={5}
            sx={{
              display: "flex",
              flexDirection: "column",
              width: {
                md: "48%",
                xs: "100%",
              },

              pt: {
                md: 2,
                xs: 0,
              },

              pb: 2,
              pl: {
                md: 2,
                xs: 0,
              },
            }}
          >
            <H3
              sx={{
                fontFamily: "'Poppins', sans-serif",
              }}
            >
              Product
            </H3>
            <Box
              sx={{
                display: "flex",
                flexDirection: {
                  md: "row",
                  xs: "column",
                },
                width: "90%",
                mt: 2,
                boxShadow: 2,
                borderRadius: 2,
                pl: 2,
                pr: 2,
                pt: 2,
                pb: 2,
                justifyContent: {
                  md: "space-between",
                  xs: "center",
                },
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: {
                    md: "row",
                    xs: "column",
                  },
                  borderRadius: 2,
                  alignItems: "center",
                }}
              >
                <Box
                  component="img"
                  sx={{
                    height: 50,
                    minwidth: {
                      md: 50,
                      xs: 70,
                      sm: 70,
                    },
                  }}
                  src={selected.imageUrl}
                  alt="saas-dasboard-footer"
                />
                <Box
                  sx={{
                    flexDirection: "column",
                    display: "flex",
                    ml: 1,
                  }}
                >
                  <Small
                    sx={{
                      textAlign: {
                        md: "left",
                        xs: "center",
                      },
                      fontFamily: "'Poppins', sans-serif",
                      fontSize: 12,
                    }}
                    fontWeight={"500"}
                    color="#0C0C0C"
                  >
                    {selected.descriptions}
                  </Small>
                </Box>
              </Box>
              {/* right */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: {
                    md: "row",
                    xs: "column",
                  },
                  width: "50%",
                  justifyContent: {
                    md: "flex-end",
                    xs: "center",
                  },
                  borderRadius: 2,
                  mt: 2,
                }}
              >
                <Box
                  sx={{
                    borderRadius: 2,
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "space-between",

                    mb: 1,
                    width: {
                      md: "60%",
                      xs: "100%",
                    },
                    alignItems: "center",
                  }}
                >
                  <Box
                    onClick={handleDecrement}
                    component="img"
                    sx={{
                      height: 30,
                      minwidth: {
                        md: 30,
                        xs: 70,
                        sm: 70,
                      },
                      mr: 1,
                      cursor: "pointer",
                    }}
                    src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/decrement.svg"
                    alt="saas-dasboard-footer"
                  />
                  <Box
                    sx={{
                      borderRadius: 2,
                      flexDirection: "row",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: 14,
                      width: 280,
                      fontFamily: "'Poppins', sans-serif",
                      borderWidth: "1px", // set the left border width to 2 pixels
                      borderStyle: "solid", // set the left border style to solid
                      borderColor: "#bbb",
                      pt: 0.5,
                      pb: 0.5,
                      fontWeight: "700",
                    }}
                  >
                    {count}
                  </Box>
                  <Box
                    onClick={handleIncrement}
                    component="img"
                    sx={{
                      height: 30,
                      minwidth: {
                        md: 30,
                        xs: 70,
                        sm: 70,
                      },
                      ml: 1,
                      cursor: "pointer",
                    }}
                    src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/increment.svg"
                    alt="saas-dasboard-footer"
                  />
                </Box>
              </Box>
            </Box>
            <H3
              sx={{
                fontFamily: "'Poppins', sans-serif",

                pt: 2,
              }}
            >
              Select Address
            </H3>

            <RadioGroup
              aria-label="address"
              name="address"
              value={selectedAddress}
              onChange={(event: any) => {
                setSelectedAddress(event.target.value);

                setFinalData(getaddressData[event.target.value]);
              }}
            >
              <FormControl>
                {getaddressData.map((item: any, index: number) => (
                  <FormControlLabel
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "89%",

                      borderRadius: 2,
                      mt: 2,

                      // justifyContent: "space-between",
                    }}
                    value={index}
                    control={<Radio />}
                    label={
                      <Small
                        sx={{
                          textAlign: "left",
                          fontFamily: "'Poppins', sans-serif",
                          fontSize: 12,
                        }}
                        fontWeight={"500"}
                        color="#0C0C0C"
                      >
                        {item?.fullName} {item?.line1}{" "}
                        {item?.optionalAddress
                          ? `, ${item?.optionalAddress}`
                          : ""}
                        {item?.city}, {item?.state}
                        <br></br>Pincode - {item?.pinCode}, Mobile no. -{" "}
                        {item?.addressMobileNo}
                      </Small>
                    }
                  />
                ))}
              </FormControl>
            </RadioGroup>

            <Box
              sx={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "95%",
                mt: {
                  xs: 2,
                },
              }}
            >
              <Button
                disableElevation
                disableRipple
                size="medium"
                sx={{
                  background: "transparent",
                  color: process.env.REACT_APP_PRIMARY_COLOR,
                  width: {
                    md: "50%",
                    xs: "100%",
                  },
                  mb: 1,
                  borderRadius: 2,
                  textTransform: "none",
                }}
                onClick={handleOpenModal}
              >
                <AddIcon
                  style={{
                    color: process.env.REACT_APP_PRIMARY_COLOR,
                  }}
                />
                Add New Address
              </Button>
            </Box>
          </Grid>
          {/* right container */}
          <Grid
            xs={12}
            md={5}
            sx={{
              display: "flex",
              flexDirection: "column",
              width: {
                md: "48%",
                xs: "100%",
              },
              p: {
                md: 1,
                xs: 0,
              },
            }}
          >
            <H3
              sx={{
                fontFamily: "'Poppins', sans-serif",

                pt: 1,
              }}
            >
              Payment Summary
            </H3>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                width: "90%",
                mt: 2,
                pl: 2,
                pr: 2,
                pt: 1,
                pb: 1,
                justifyContent: "space-between",
                border: "0.5px solid #E4E4E4",
              }}
            >
              <Small
                sx={{
                  mt: 0.4,
                  fontFamily: "'Poppins', sans-serif",
                  fontSize: 12,
                }}
                fontWeight={"500"}
                color="#000"
              >
                Total Price
              </Small>
              <Small
                sx={{
                  mt: 0.4,
                  fontSize: 12,
                }}
                fontWeight={"700"}
                color="#000"
              >
                ₹
                <Small
                  sx={{
                    mt: 0.4,
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: 12,
                  }}
                  fontWeight={"700"}
                  color="#000"
                >
                  {(selected.basePrice * count).toFixed(2)}
                </Small>
              </Small>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                width: "90%",
                pl: 2,
                pr: 2,
                pt: 1,
                pb: 1,
                justifyContent: "space-between",
                border: "0.5px solid #E4E4E4",
                borderTop: "0px",
              }}
            >
              <Small
                sx={{
                  mt: 0.4,
                  fontFamily: "'Poppins', sans-serif",
                  fontSize: 12,
                }}
                fontWeight={"500"}
                color="#000"
              >
                GST
              </Small>
              <Small
                sx={{
                  mt: 0.4,
                  fontSize: 12,
                }}
                fontWeight={"700"}
                color="#000"
              >
                ₹
                <Small
                  sx={{
                    mt: 0.4,
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: 12,
                  }}
                  fontWeight={"700"}
                  color="#000"
                >
                  {(selected.gst * count).toFixed(2)}
                </Small>
              </Small>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                width: "90%",
                pl: 2,
                pr: 2,
                pt: 1,
                pb: 1,
                justifyContent: "space-between",
                border: "0.5px solid #E4E4E4",
                borderTop: "0px",
              }}
            >
              <Small
                sx={{
                  mt: 0.4,
                  fontFamily: "'Poppins', sans-serif",
                  fontSize: 12,
                }}
                fontWeight={"500"}
                color="#000"
              >
                Payable Amount
              </Small>
              <Small
                sx={{
                  mt: 0.4,
                  fontSize: 12,
                }}
                fontWeight={"700"}
                color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
              >
                ₹
                <Small
                  sx={{
                    mt: 0.4,
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: 12,
                  }}
                  fontWeight={"700"}
                  color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                >
                  {(count * selected.basePrice + count * selected.gst).toFixed(
                    2
                  )}
                </Small>
              </Small>
            </Box>
            <Box
              sx={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                onClick={onProceed}
                disableElevation
                disableRipple
                size="medium"
                sx={{
                  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                  color: "#fff",
                  width: {
                    md: "50%",
                    xs: "100%",
                  },
                  mb: 1,
                  mt: 2,
                  borderRadius: 2,
                  textTransform: "none",
                }}
              >
                Proceed to Payment
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default CoinPriceBreakup;
